import { Badge } from 'antd';
import { Tooltip } from 'farmhub-ui-core';

import { theme } from 'styled';

import { CTag } from './styles';

interface GroupTagProps {
  color?: string;
  tooltipContent?: React.ReactNode;
  name?: string | React.ReactNode;
  active?: boolean;
  quantity?: number;
  icon?: React.ReactNode;
  margin?: number;
  height?: string;
  borderRadius?: string;
  size?: 'small' | 'default' | undefined;
  offset?: [number, number];
  onClick?: (e: any) => void;
}

const GroupTag = ({
  tooltipContent,
  color,
  name,
  quantity,
  icon,
  active,
  margin = 14,
  height,
  borderRadius,
  size = 'default',
  offset,
  onClick,
}: GroupTagProps): JSX.Element => (
  <Badge count={quantity} offset={offset || [-16, -2]} size={size}>
    <CTag
      borderRadius={borderRadius}
      color={color}
      height={height}
      icon={icon}
      margin={margin}
      onClick={onClick}
    >
      <Tooltip title={tooltipContent}>
        <span className="span text">{name}</span>
      </Tooltip>
    </CTag>
  </Badge>
);

export default GroupTag;
